import { ReactComponent as FileIcon } from "assets/article-line.svg";
import Typography from "components/common/Typography";
import { useAppSelector } from "redux/hooks";
import { tokens } from "styles/Tokens";
import BubbleToggle from "../BubbleToggle";
import "./index.scss";

export default function Preview() {
  const previewList = useAppSelector((state) => state.PlanAssignment.previewList);

  return (
    <div className="assignment_preview">
      <div className="assignment_preview-heading">
        <Typography
          className="assignment_preview-heading-title"
          variant="h5"
          changeVariant={false}
          color={tokens.Text.General.PrimaryHeadline}
        >
          You have selected plans that are not applicable for some inncodes.
        </Typography>
        <BubbleToggle />
      </div>

      <div className="assignment_preview-plans">
        <Typography showBold variant="body2" color={tokens.Text.General.Secondary}>
          Plans
        </Typography>
        <div className="assignment_preview-plansList">
          {previewList.map((plan: any) => {
            return (
              <div>
                <div className="assignment_preview-planName">
                  <div>
                    <FileIcon />
                  </div>
                  <Typography variant="body2" color={tokens.Text.General.Secondary}>
                    {plan.title}
                  </Typography>
                </div>
                <div className="assignment_preview-inncodesList">
                  {plan.notAvailableReason?.map(({ reason, innCodes }: any) => {
                    return (
                      <div>
                        <Typography variant="body2" color={tokens.Text.General.Secondary}>
                          {reason}
                        </Typography>
                        <Typography variant="body2" color={tokens.Text.Feedback.Alert}>
                          {innCodes.join(", ")}
                        </Typography>
                      </div>
                    );
                  })}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
